import React from "react";
import "../css/Pricing.css";

const Pricing = () => {
  return (
    <div className="pricing5">

      {/* ======================================================
          HERO — EARTH BANDS HEADER
      ======================================================= */}
      <section className="pr5-hero">
        <h1>Plans Rooted in Balance</h1>
        <p>Choose a pace that supports your natural growth.</p>

        <div className="pr5-bands">
          <span></span><span></span><span></span>
        </div>
      </section>



      {/* ======================================================
          NATURAL PLAN CARDS
      ======================================================= */}
      <section className="pr5-plans">

        <div className="pr5-card">
          <h3>Foundations</h3>
          <h2>$39 <span>/ month</span></h2>
          <ul>
            <li>Strength + Mobility Mix</li>
            <li>Basic Tracking</li>
            <li>Unlimited Classes</li>
          </ul>
        </div>

        <div className="pr5-card highlight">
          <div className="tag">Popular</div>
          <h3>Earthflow</h3>
          <h2>$69 <span>/ month</span></h2>
          <ul>
            <li>Full Class Access</li>
            <li>Deep Mobility Program</li>
            <li>Nutrition Basics</li>
            <li>Recovery Sessions</li>
          </ul>
        </div>

        <div className="pr5-card">
          <h3>Holistic+</h3>
          <h2>$119 <span>/ month</span></h2>
          <ul>
            <li>Personal Coaching</li>
            <li>Advanced Tracking</li>
            <li>Custom Weekly Plan</li>
            <li>Priority Booking</li>
          </ul>
        </div>

      </section>



      {/* ======================================================
          EARTH FEATURE GRID
      ======================================================= */}
      <section className="pr5-features">
        <h2>Everything You Need to Grow Naturally</h2>

        <div className="feat-grid">
          <div className="feat-item">
            <h3>Rooted Strength</h3>
            <p>Build stability from the ground up using mindful form.</p>
          </div>

          <div className="feat-item">
            <h3>Breath-Led Flow</h3>
            <p>Move in sync with breath to reduce stress and boost control.</p>
          </div>

          <div className="feat-item">
            <h3>Holistic Recovery</h3>
            <p>Sustainable progress powered by rest and recalibration.</p>
          </div>

          <div className="feat-item">
            <h3>Community Support</h3>
            <p>Train with people who value balance and growth.</p>
          </div>
        </div>
      </section>



      {/* ======================================================
          SIMPLE RESPONSIVE EARTH TABLE
      ======================================================= */}
      <section className="pr5-compare">
        <h2>Compare Plans</h2>

        <div className="pr5-table-wrapper">

          {/* DESKTOP TABLE */}
          <table className="pr5-table">
            <thead>
              <tr>
                <th>Feature</th>
                <th>Foundations</th>
                <th>Earthflow</th>
                <th>Holistic+</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Classes</td>
                <td>Unlimited</td>
                <td>Unlimited</td>
                <td>Unlimited</td>
              </tr>

              <tr>
                <td>Mobility Program</td>
                <td>Basic</td>
                <td>Advanced</td>
                <td>Advanced</td>
              </tr>

              <tr>
                <td>Nutrition</td>
                <td>—</td>
                <td>Basics</td>
                <td>Custom Plan</td>
              </tr>

              <tr>
                <td>1:1 Coaching</td>
                <td>—</td>
                <td>—</td>
                <td>Included</td>
              </tr>

              <tr>
                <td>Analytics</td>
                <td>Basic</td>
                <td>Intermediate</td>
                <td>Advanced</td>
              </tr>
            </tbody>
          </table>

          {/* MOBILE CARDS */}
          <div className="pr5-mobile-card">
            <h4>Foundations</h4>
            <div className="pr5-mobile-row"><span>Classes</span><span>Unlimited</span></div>
            <div className="pr5-mobile-row"><span>Mobility</span><span>Basic</span></div>
            <div className="pr5-mobile-row"><span>Nutrition</span><span>—</span></div>
            <div className="pr5-mobile-row"><span>1:1 Coaching</span><span>—</span></div>
            <div className="pr5-mobile-row"><span>Analytics</span><span>Basic</span></div>
          </div>

          <div className="pr5-mobile-card">
            <h4>Earthflow</h4>
            <div className="pr5-mobile-row"><span>Classes</span><span>Unlimited</span></div>
            <div className="pr5-mobile-row"><span>Mobility</span><span>Advanced</span></div>
            <div className="pr5-mobile-row"><span>Nutrition</span><span>Basics</span></div>
            <div className="pr5-mobile-row"><span>1:1 Coaching</span><span>—</span></div>
            <div className="pr5-mobile-row"><span>Analytics</span><span>Intermediate</span></div>
          </div>

          <div className="pr5-mobile-card">
            <h4>Holistic+</h4>
            <div className="pr5-mobile-row"><span>Classes</span><span>Unlimited</span></div>
            <div className="pr5-mobile-row"><span>Mobility</span><span>Advanced</span></div>
            <div className="pr5-mobile-row"><span>Nutrition</span><span>Custom</span></div>
            <div className="pr5-mobile-row"><span>1:1 Coaching</span><span>Included</span></div>
            <div className="pr5-mobile-row"><span>Analytics</span><span>Advanced</span></div>
          </div>

        </div>
      </section>



      {/* ======================================================
          EARTH END PANEL
      ======================================================= */}
      <section className="pr5-end">
        <h2>Grow At Your Own Rhythm</h2>
        <p>Start slow, deepen with intention, rise naturally.</p>
      </section>

    </div>
  );
};

export default Pricing;
